import { PocProgressSpinner } from 'commons/components/components-wrapper/poc-progress-spinner.component';
import { CleaningStatusTrackingCard } from './components/cleaning-status-tracking-card/cleaning-status-tracking-card.component';
import { ConnectivityStatusTrackingCard } from './components/connectivity-status-tracking-card/connectivity-status-tracking-card.component';
import { QcStatusTrackingCard } from './components/qc-status-tracking-card/qc-status-tracking-card.component';
import { useSettingsDeviceConfigurationStatusTracking } from './hooks/use-settings-device-configuration-status-tracking/use-settings-device-configuration-status-tracking.hook';
import {
    ConfigStatusTrackingCardsContentStyled,
    ConfigStatusTrackingContainerStyled,
} from './settings-device-configuration-status-tracking.style';

export const SettingsDevicesConfigStatusTrackingContainer: React.FC = () => {
    const {
        config,
        isLoading,
        handleValidityChange,
        handleConnectivityPropertiesChange,
        handleQcPropertiesChange,
        handleCleaningPropertiesChange,
    } = useSettingsDeviceConfigurationStatusTracking();

    return (
        <ConfigStatusTrackingContainerStyled>
            <ConfigStatusTrackingCardsContentStyled>
                {isLoading || !config ? (
                    <PocProgressSpinner />
                ) : (
                    <>
                        <ConnectivityStatusTrackingCard
                            values={config.connectivityProperties}
                            onValidityChange={(isValid) => handleValidityChange('connectivityProperties', isValid)}
                            onValuesChange={handleConnectivityPropertiesChange}
                        />
                        {config.cleaningProperties && (
                            <CleaningStatusTrackingCard
                                values={config.cleaningProperties}
                                onValidityChange={(isValid) => handleValidityChange('cleaningProperties', isValid)}
                                onValuesChange={handleCleaningPropertiesChange}
                            />
                        )}
                        <QcStatusTrackingCard
                            values={config.qcProperties}
                            onValidityChange={(isValid) => handleValidityChange('qcProperties', isValid)}
                            onValuesChange={handleQcPropertiesChange}
                        />
                    </>
                )}
            </ConfigStatusTrackingCardsContentStyled>
        </ConfigStatusTrackingContainerStyled>
    );
};
